class Ratings {
  constructor() {
    this.productCardRatingClicked = this.productCardRatingClicked.bind(this);
    this.initBehavior();
  }

  // Private

  initBehavior() {
    return $(document).on(
      'click',
      '.pc-ProductCard .pc-Rating',
      this.productCardRatingClicked
    );
  }

  toCard(e) {
    const card = $(e.target);
    if (card.is('.pc-ProductCard')) {
      return card;
    }
    return card.closest('.pc-ProductCard');
  }

  productCardRatingClicked(e) {
    const card = this.toCard(e);
    const action = $.trim(card.find('[itemprop=name]').text());
    return CustomInk.Metrics.fireEvent({
      category: 'product cardrating',
      action
    });
  }
}

jQuery(() => (ProductCatalog.Ratings = new Ratings()));
